var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeDegreeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7571 0.0728756C12.5488 -0.0242919 12.3083 -0.0242919 12.1001 0.0728756L0.448296 5.51038C0.167652 5.64134 -0.00838158 5.9265 0.000307598 6.23608C0.00899673 6.54566 0.200748 6.82049 0.488296 6.93551L12.1401 11.5962C12.3253 11.6703 12.5319 11.6703 12.7171 11.5962L21.75 7.98305V17.0893C20.892 17.0893 20.1964 17.7848 20.1964 18.6429V21.75H24.8571V18.6429C24.8571 17.7848 24.1616 17.0893 23.3036 17.0893V7.36162L24.3688 6.93551C24.6564 6.82049 24.8481 6.54566 24.8568 6.23608C24.8655 5.9265 24.6895 5.64134 24.4088 5.51038L12.7571 0.0728756ZM12.4286 10.0384L2.73121 6.15943L12.4286 1.63399L22.1259 6.15943L12.4286 10.0384Z",
    fill: "#E1CE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48703 10.9245C6.28495 10.8487 6.06046 10.8604 5.86736 10.9568C5.67426 11.0532 5.52996 11.2256 5.46907 11.4326L4.69228 14.0737C4.57924 14.458 4.77704 14.8653 5.14901 15.0141L12.1401 17.8105C12.3253 17.8846 12.5319 17.8846 12.7171 17.8105L19.7081 15.0141C20.0801 14.8653 20.2779 14.458 20.1649 14.0737L19.3881 11.4326C19.3272 11.2256 19.1829 11.0532 18.9898 10.9568C18.7967 10.8604 18.5722 10.8487 18.3701 10.9245L12.4286 13.1525L6.48703 10.9245ZM6.38212 13.8341L6.72378 12.6725L12.1558 14.7095C12.3317 14.7754 12.5255 14.7754 12.7013 14.7095L18.1334 12.6725L18.475 13.8341L12.4286 16.2527L6.38212 13.8341Z",
    fill: "#E1CE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeDegreeIcon);
export default __webpack_public_path__ + "static/media/orange-degree-icon.1e3b44e4609fc5a0307cd5b392ea2935.svg";
export { ForwardRef as ReactComponent };